import { useEffect, useState } from 'react';
import { Button } from 'primereact/button';

const InstallPromptComponent = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const beforeInstall = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setShowPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', beforeInstall);
    return () => window.removeEventListener('beforeinstallprompt', beforeInstall);
  }, []);

  const installApp = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div className="install-prompt-card shadow-4 border-round p-2">
      <div className="text-sm mb-2">Install Freeliefs on your phone for quick access.</div>
      <div className="flex gap-2">
        <Button label="Install" size="small" onClick={installApp} />
        <Button label="Later" size="small" outlined onClick={() => setShowPrompt(false)} />
      </div>
    </div>
  );
};

export default InstallPromptComponent;
